(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointDialogController', ParCurvePointDialogController);

    ParCurvePointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ParCurvePoint', 'YieldCurveResults'];

    function ParCurvePointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ParCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.parCurvePoint = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.parCurvePoint.id !== null) {
                ParCurvePoint.update(vm.parCurvePoint, onSaveSuccess, onSaveError);
            } else {
                ParCurvePoint.save(vm.parCurvePoint, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:parCurvePointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
